import {Service} from './request';

export default {
    getUserDetail(userId) {
        let param = {
            "userId": userId
        };
        return Service.post('/user/detail/get', param);
    },
    logout() {
        return Service.post("/logout")
    }
}